module.exports = __webpack_public_path__ + "img/ch18_05_揉头加餐.a65416cf.jpg";